"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const jsonview = require("../../../jsonview/index");
const modal_1 = require("../../../modal");
class DrillObjectComponent extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleOnCerrar = () => this.props.onCerrar(null);
        this.handleOnDrill = (path) => this.props.onCerrar(path);
    }
    render() {
        const props = this.props;
        return (props.show ?
            React.createElement(modal_1.Modal, { buttons: [], onClose: this.handleOnCerrar, title: "Ver objeto" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(jsonview.Json, { value: props.value, onPropClick: this.handleOnDrill })))) : null);
    }
}
exports.DrillObjectComponent = DrillObjectComponent;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/cells/drillObjectModal.js
// module id = 2216
// module chunks = 0